import { Vector4 } from "three";
import { getRohRectMesh, drawRohRegions } from "./rohBlueprint";
import { ROH_CL } from "../../constants/options";
import RohRegion from "../../../../models/RohRegion";
import ColorScale from "../../models/ColorScale";

function getDefaultState(track) {
  const { previewId } = track.getSharedState();
  return {
    sampleId: previewId || track?.conf?.data?.sample?.id,
    rohData: [],
    config: {},
    minY: 0,
    maxY: 1,
  };
}

function rohTrackController(track) {
  let state = getDefaultState(track);
  const rectMesh = getRohRectMesh();

  function onRangeChange({ genome }) {
    const params = { sampleId: state.sampleId };
    const segs = genome.chrs.map((x) => ({
      ...x.region,
      size: x.region.size,
      x0: 0,
      x1: x.region.size,
      chr: x,
    }));
    track.loadPosition(segs, params);
  }

  function onReset() {
    state = getDefaultState(track);
  }

  function onPreferencesChanged() {
    const config = track.getPreferences();
    state.config = config;
    const { isDark } = config;
    const scaleName = config[ROH_CL];
    const { vectors } = new ColorScale(scaleName, 5).setTheme(isDark ? 2 : 1);
    const vecs = [...vectors, new Vector4(0.5, 0.5, 0.5, 1), new Vector4()];
    rectMesh.uniforms.setColorMap(vecs);
    track.requestRender();
  }

  function onDataReceived({ res }) {
    const { genome: gen } = track.zoomService;
    const rohContent = typeof res === "string" ? res : "";
    const rohData = rohContent
      .split("\n")
      .filter((x) => x.length)
      .map((x) => x.split("\t"))
      .map((x) => ({ chr: x[0], start: Number(x[1]), end: Number(x[2]) }))
      .map((x) => ({ ...x, chr: gen.getChrByName(x.chr) }))
      .map((x) => new RohRegion(x.chr, x.start, x.end));

    state.rohData = state.rohData.concat(rohData);
    rectMesh.setItems(state.rohData);
    drawRohRegions(rohData, rectMesh);
    track.requestRender();
  }

  function onSharedStateChange() {
    const { previewId } = track.getSharedState();
    if (previewId !== state.sampleId) {
      track.reset();
    }
  }

  return {
    onReset,
    onSharedStateChange,
    onRangeChange,
    onDataReceived,
    onPreferencesChanged,
    meshes: [rectMesh],
  };
}

export default rohTrackController;
